import { render, staticRenderFns } from "./EditPayPassword.vue?vue&type=template&id=3ca0e2ca&scoped=true"
import script from "./EditPayPassword.vue?vue&type=script&lang=js"
export * from "./EditPayPassword.vue?vue&type=script&lang=js"
import style0 from "./EditPayPassword.vue?vue&type=style&index=0&id=3ca0e2ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0e2ca",
  null
  
)

export default component.exports